import { AxiosError } from "axios";
import { TlxHttpResponse } from "@/api";

export const defaultErrorMessage =
  "Retry after sometime as the data source request is taking longer than the expected time to finish.";
// export const defaultErrorMessage503 =
//   "Something is wrong, request processing taking more time than usual. Please retry after sometime.";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getDefaultErrorMessage = (error?: AxiosError<TlxHttpResponse>) =>
  defaultErrorMessage;
// [503, 504].includes(error?.response?.status as number)
//   ? defaultErrorMessage503
//   : defaultErrorMessage
